<kui-card [@slideInOut]="align">
    @if (tabs) {
        <ng-container>
            <kui-card-header class="p-0">
                <kui-tab-bar [stretchItems]="true" [items]="tabs" (selection)="tabSelection.emit($event)"></kui-tab-bar>
            </kui-card-header>
        </ng-container>
    }

    <kui-card-body class="overflow-auto">
        <ng-content></ng-content>
    </kui-card-body>

    @if (undo || redo || cancel || save) {
        <ng-container>
            <kui-card-footer align="right">
                @if (undo) {
                    <button (click)="onUndo.emit($event)" kui-button color="none" [kui-tooltip]="'SHARED.UNDO' | translate">
                        <kui-icon name="reply"></kui-icon>
                    </button>
                }
                @if (redo) {
                    <button (click)="onRedo.emit($event)" kui-button color="none" [kui-tooltip]="'SHARED.REDO' | translate">
                        <kui-icon name="redo"></kui-icon>
                    </button>
                }
                @if (cancel) {
                    <button (click)="onCancel.emit($event)" kui-button color="danger" [kui-tooltip]="'SHARED.CANCEL' | translate">
                        <kui-icon name="ban"></kui-icon>
                    </button>
                }
                @if (save) {
                    <button (click)="onSave.emit($event)" kui-button color="success" [kui-tooltip]="'SHARED.SAVE' | translate">
                        <kui-icon name="save"></kui-icon>
                    </button>
                }
            </kui-card-footer>
        </ng-container>
    }
</kui-card>
